import React from "react";
import { Link, useHistory } from "react-router-dom";
import UserProfile from "../images/avatar-defaul-girls.jpg";
import { url } from "../utils/url";
import UserContext from "../UserContext";

export default function Comments({
  data: comments = [],
  post = {},
  showFew = true,
}) {
  const { mode } = React.useContext(UserContext);

  let [displayComments, setdisplayComments] = React.useState([]);
  React.useEffect(() => {
    if (showFew) {
      let length = comments.length;
      if (length > 2) {
        setdisplayComments([comments[length - 2], comments[length - 1]]);
      } else {
        setdisplayComments(comments);
      }
    } else {
      setdisplayComments(comments);
    }
  }, [comments, showFew]);
  const history = useHistory();
  // setting the theme

  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <>
      {comments.length !== 0 ? (
        <div
          className={
            dark
              ? "comments divbg-in-darkmode text-muted"
              : "comments card-footer text-muted"
          }
        >
          {comments.length > 2 && showFew ? (
            <Link to={`/p/${post._id}`}>
              View All {comments.length} comments
            </Link>
          ) : (
            <p className="font-weight-bolder">
              {comments.length > 1
                ? comments.length + " Comments"
                : comments.length === 1
                ? comments.length + " Comment"
                : "No comments"}
            </p>
          )}
          <div
            className={
              dark
                ? "mt-3 text-black darkmode divbg-in-darkmode"
                : "mt-3 text-black"
            }
          >
            {displayComments.map((comment) => {
              return (
                <div
                  key={comment._id}
                  className="comment d-flex justify-content-start align-items-center"
                >
                  <img
                    src={
                      `${
                        comment.author?.image
                          ? comment.author?.image
                          : url + comment.author?.profile?.url
                      }` || UserProfile
                    }
                    alt="Commented user"
                    className="comment-profile mr-2 mb-2 object-cover"
                    title={comment.author?.names}
                    onClick={() => {
                      history.push(`/users/${comment.author?.username}`);
                    }}
                  />
                  <div className="comment__content w-full">
                    {comment.content?.length > 120
                      ? comment.content?.slice(0, 120) + " ..."
                      : comment.content}
                    <br />
                      <div className="w-full flex text-xs my-1">
                        {/* toUTCString */}
                        <small className="text-gray-400">{new Date(parseInt(comment.commentOn)).toDateString()}</small>
                     
                      <small className="flex items-center gap-1">
                        {" "}
                        , by {comment.author?.username}{" "}
                        {comment.author?.account_type === "VERIFIED" && (
                          <div title="Account verified">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="15"
                              height="15"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path
                                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                                fill="rgba(249,2,2,1)"
                              />
                            </svg>
                          </div>
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}